import {
  revolutSettings,
  PAYMENT_METHODS,
  i18n,
  dispatch,
  CHECKOUT_PAYMENT_CONTEXT,
} from '../../utils'
import { RevolutPay } from './revolut-pay'
import { BlockLabel } from '../components'

const { PAYMENT_STORE_KEY } = window.wc.wcBlocksData

const settings = revolutSettings(PAYMENT_METHODS.REVOLUT_PAY)

const urlParams = new URLSearchParams(window.location.search)
const declineReason = urlParams.get('_rp_fr')
const revolutOrderPublicToken = urlParams.get('_rp_oid')
const paymentSuccess = urlParams.get('_rp_s')

if (declineReason || (!paymentSuccess && revolutOrderPublicToken)) {
  dispatch('core/notices').createErrorNotice(i18n(declineReason || 'Payment Rejected'), {
    id: 'rp-fr',
    context: CHECKOUT_PAYMENT_CONTEXT,
  })

  dispatch(PAYMENT_STORE_KEY).__internalSetActivePaymentMethod(
    PAYMENT_METHODS.REVOLUT_PAY,
  )
}

const RevolutPayBlock = {
  name: 'revolut_pay',
  label: <BlockLabel settings={settings} />,
  content: <RevolutPay />,
  edit: <p>{i18n('Revolut Pay is not available in editor mode')}</p>,
  ariaLabel: 'Revolut Pay',
  canMakePayment: () => settings.can_make_payment,
  paymentMethodId: 'revolut_pay',
  supports: {
    features: ['products'],
  },
}
export default RevolutPayBlock
